import React from 'react';
import styles from './Logo.module.css';

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ size = 'md', showText = false }) => {
  const sizeMap = {
    sm: 32,
    md: 40,
    lg: 56,
  };

  const iconSize = sizeMap[size];

  return (
    <div className={styles.logo}>
      <div className={styles.iconWrapper} style={{ width: iconSize, height: iconSize }}>
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#2563EB" />
              <stop offset="100%" stopColor="#0F172A" />
            </linearGradient>
          </defs>
          <circle cx="20" cy="20" r="18" fill="url(#logoGradient)" />
          <path
            d="M27 14C27 14 25 12 20 12C15 12 13 14 13 14C13 14 11 16 11 20C11 24 13 26 13 26C13 26 15 28 20 28C25 28 27 26 27 26"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
          />
          <circle cx="20" cy="20" r="3" fill="white" />
        </svg>
      </div>
      {showText && <span className={styles.text}>BrainIQ</span>}
    </div>
  );
};

export default Logo;
